import { useQuery } from '@tanstack/react-query';
import { User } from '@companion-professional/dctypes';
import { getUsersInLoggedInClinic } from '../lib/api';
import { useClinicId } from '../state/auth';

export const useClinicUsers = () => {
  // We get the clinic id from the auth state to be used in the queryKey.  That way if the user changes clinics, the
  // query will be invalidated and refetched.
  const clinicId = useClinicId();
  const {
    isPending,
    error,
    data: users
  } = useQuery<User[]>({
    queryKey: ['users-in-clinic', clinicId],
    queryFn: () => getUsersInLoggedInClinic()
  });

  return {
    isPending,
    error,
    users
  };
};
